<!-- Darabase loader -->
<div *ngIf="activeNow" class="dara-loader-wrapper">
  <div class="dara-loader">
    <div class="dara-loader-spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <img
    alt="image"
    src="./assets/img/ktoLogo.svg"
    alt="Logo"
    class="dara-loader-logo"
  />
</div>
